// A request that never got an answer the browser could read. When the firewall in front of the
// API (Cloud Armor) blocks a request, its 403 carries no CORS headers, so the browser reports a
// network error, exactly as it does when the user is offline or the server is down (#7063,
// #6485). Nothing in the error says which, so a sign-in form must not report it as a wrong
// password or a broken invitation.
//
// Kept free of imports, like resourceGone.js, so the sign-in pages can use it without loading
// the router and stores that http.error.notifications pulls in.
export const NO_RESPONSE_MESSAGE = "We couldn't reach BestNotes to finish this step. If your internet is working, contact your provider or BestNotes support.";

/**
 * Whether an axios request failed without a response: a network error, a CORS-less block or a
 * timeout. Errors thrown by code rather than by axios are not this.
 */
export function isNoResponse(err) {
    return err?.isAxiosError === true && !err.response;
}
